import React, { useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import { Divider, ListItemIcon } from "@mui/material";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import DashboardIcon from "@mui/icons-material/Dashboard";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import { useNavigate } from "react-router-dom";
import { sweetAlert } from "../../custom-hooks/useSweetAlert";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import AccessibilityNewIcon from "@mui/icons-material/AccessibilityNew";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import AppRegistrationIcon from "@mui/icons-material/AppRegistration";
import PublicIcon from '@mui/icons-material/Public';
import AirplanemodeActiveIcon from '@mui/icons-material/AirplanemodeActive';
import AddTaskRoundedIcon from '@mui/icons-material/AddTaskRounded';
import CreateRoundedIcon from '@mui/icons-material/CreateRounded';
import MergeTypeRoundedIcon from '@mui/icons-material/MergeTypeRounded';
import BookIcon from '@mui/icons-material/Book';
import HikingIcon from '@mui/icons-material/Hiking';

const SimpleDrawer = ({ users, Signout }) => {
  const [open, setOpen] = useState(false);
  const [isAgentSectionOpen, setIsAgentSectionOpen] = useState(false);
  const [isApiLabOpen, setIsApiLabOpen] = useState(false);
  const [isLabelForPackages, SetisLabelForPackages] = useState(false);
  const [isVacationOpen, SetisVacationOpen] = useState(false);
  const [countryLocation, setCountryLocation] = useState(false);
  const [packageButton, setpackageButton] = useState(false);
  const [addBlogs, setBlogs] = useState(false);
  const [leads, setLeads] = useState(false);
  const [offers, setOffers] = useState(false);
  const [booking, setBooking] = useState(false);

  const handleBlogs = (event, isExpanded) => {
    setBlogs(isExpanded);
  };

  const toggleLeads = (event, isExpanded) => {
    setLeads(isExpanded);
  }

  const toggleOffers = (event, isExpanded) => {
    setOffers(isExpanded);
  }

  const navigate = useNavigate();

  const toggleDrawer = (value) => {
    setOpen(value);
  };
  const toggleDrawerBooking = (event, isExpanded) => {
    setBooking(isExpanded);
  };

  const handleAgentSectionChange = (event, isExpanded) => {
    setIsAgentSectionOpen(isExpanded);
  };

  const handleCountryLocation = (event, isExpanded) => {
    setCountryLocation(isExpanded);
  };

  const handlepackageSectionChange = (event, isExpanded) => {
    SetisLabelForPackages(isExpanded);
  };

  const handleisVacationOpen = (event, isExpanded) => {
    SetisVacationOpen(isExpanded);
  };

  const handlepackageButton = (event, isExpanded) => {
    setpackageButton(isExpanded);
  };

  const handleApiLabChange = (event, isExpanded) => {
    setIsApiLabOpen(isExpanded);
  };

  const signIn = [{ route: "Sign in", icon: <VpnKeyIcon />, to: "/" }];

  const list = (
    <List>
      <>
        {users.auth ? (
          <>
            <ListItem>
              {/* <ListItemIcon>
                {/* <DashboardIcon style={{ color: '#2f034d' }} /> */}
              {/* </ListItemIcon> */}
              <ListItemText
                primary={`Hi 👋 ${users?.data?.userName?.toUpperCase()}`}
              />
            </ListItem>

            <ListItem
              button
              component={RouterLink}
              to="/dashboard"
              onClick={() => toggleDrawer(false)}
            >
              <ListItemIcon>
                <DashboardIcon style={{ color: '#2f034d' }} />
              </ListItemIcon>
              <ListItemText primary="Dashboard" />
            </ListItem>

            <Divider sx={{ borderTop: "3px solid lightgrey" }} />
            {(users?.data?.roleId === 1 || users?.data?.roleId === 2) && (
              <Accordion
                expanded={isAgentSectionOpen}
                onChange={handleAgentSectionChange}
                disableGutters
                style={{ border: "none", borderRadius: "5px" }}
                sx={{ width: "100%", border: "none" }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="agent-section-content"
                  id="agent-section-header"
                  sx={{
                    paddingLeft: "15px",
                    "& .MuiAccordionSummary-content": {
                      margin: 0,
                    },
                  }}
                >
                  <ListItemIcon>
                    <SupportAgentIcon style={{ color: '#2f034d' }} />
                  </ListItemIcon>
                  <ListItemText primary="Agent Section" />
                </AccordionSummary>
                <AccordionDetails sx={{ padding: "0 16px" }}>
                  <ListItem
                    button
                    onClick={() => {
                      navigate("/dashboard/add-user");
                      toggleDrawer(false);
                    }}
                  >
                    <ListItemIcon>
                      <AppRegistrationIcon style={{ color: '#2f034d' }} />
                    </ListItemIcon>
                    <ListItemText primary="Register Agent" />
                  </ListItem>

                  <ListItem
                    button
                    onClick={() => {
                      navigate("/dashboard/get-users");
                      toggleDrawer(false);
                    }}
                  >
                    <ListItemIcon>
                      <AccessibilityNewIcon style={{ color: '#2f034d' }} />
                    </ListItemIcon>
                    <ListItemText primary="Agent Access" />
                  </ListItem>
                </AccordionDetails>
              </Accordion>
            )}

            <Accordion
              expanded={isApiLabOpen}
              onChange={handleApiLabChange}
              disableGutters
              style={{ border: "none", marginTop: '0.5rem', borderRadius: "5px" }}
              sx={{ width: "100%", border: "none" }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="agent-section-content"
                id="agent-section-header"
                sx={{
                  paddingLeft: "15px",
                  "& .MuiAccordionSummary-content": {
                    margin: 0,
                  },
                }}
              >
                <ListItemIcon>
                  <PublicIcon style={{ color: '#2f034d' }} />
                </ListItemIcon>
                <ListItemText primary="Country" />
              </AccordionSummary>
              <AccordionDetails sx={{ padding: "0 16px" }}>
                <ListItem
                  button
                  onClick={() => {
                    navigate("/dashboard/add-country");
                    toggleDrawer(false);
                  }}
                >
                  <ListItemIcon>
                    <AppRegistrationIcon style={{ color: '#2f034d' }} />
                  </ListItemIcon>
                  <ListItemText primary="Add Country" />
                </ListItem>

                <ListItem
                  button
                  onClick={() => {
                    navigate("/dashboard/get-country");
                    toggleDrawer(false);
                  }}
                >
                  <ListItemIcon>
                    <AccessibilityNewIcon style={{ color: '#2f034d' }} />
                  </ListItemIcon>
                  <ListItemText primary="View Country" />
                </ListItem>
              </AccordionDetails>
            </Accordion>

            {/* <Accordion
              expanded={isVacationOpen}
              onChange={handleisVacationOpen}
              disableGutters
              style={{ border: "none", marginTop: '0.5rem' }}
              sx={{ width: "100%", border: "none" }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="agent-section-content"
                id="agent-section-header"
                sx={{
                  paddingLeft: "15px",
                  "& .MuiAccordionSummary-content": {
                    margin: 0,
                  },
                }}
              >
                <ListItemIcon>
                  <SentimentSatisfiedAltIcon style={{ color: '#2f034d' }} />
                </ListItemIcon>
                <ListItemText primary="Vacation Type" />
              </AccordionSummary>
              <AccordionDetails sx={{ padding: "0 16px" }}>
                <ListItem
                  button
                  onClick={() => {
                    navigate("/dashboard/add-vacation-type");
                    toggleDrawer(false);
                  }}
                >
                  <ListItemIcon>
                    <AppRegistrationIcon style={{ color: '#2f034d' }} />
                  </ListItemIcon>
                  <ListItemText primary="Add Vacation Type" />
                </ListItem>

                <ListItem
                  button
                  onClick={() => {
                    navigate("/dashboard/view-vacation-type");
                    toggleDrawer(false);
                  }}
                >
                  <ListItemIcon>
                    <AccessibilityNewIcon style={{ color: '#2f034d' }} />
                  </ListItemIcon>
                  <ListItemText primary="View Vacation Type" />
                </ListItem>
              </AccordionDetails>
            </Accordion> */}

            <Accordion
              expanded={isLabelForPackages}
              onChange={handlepackageSectionChange}
              disableGutters
              style={{ border: "none", marginTop: '0.5rem', borderRadius: "5px" }}
              sx={{ width: "100%", border: "none" }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="agent-section-content"
                id="agent-section-header"
                sx={{
                  paddingLeft: "15px",
                  "& .MuiAccordionSummary-content": {
                    margin: 0,
                  },
                }}
              >
                <ListItemIcon>
                  <MergeTypeRoundedIcon style={{ color: '#2f034d' }} />
                </ListItemIcon>
                <ListItemText primary="Packages Type" />
              </AccordionSummary>
              <AccordionDetails sx={{ padding: "0 16px" }}>
                <ListItem
                  button
                  onClick={() => {
                    navigate("/dashboard/add-package");
                    toggleDrawer(false);
                  }}
                >
                  <ListItemIcon>
                    <AppRegistrationIcon style={{ color: '#2f034d' }} />
                  </ListItemIcon>
                  <ListItemText primary="Add Packages Type" />
                </ListItem>

                <ListItem
                  button
                  onClick={() => {
                    navigate("/dashboard/view-package");
                    toggleDrawer(false);
                  }}
                >
                  <ListItemIcon>
                    <AccessibilityNewIcon style={{ color: '#2f034d' }} />
                  </ListItemIcon>
                  <ListItemText primary="View Packages Type" />
                </ListItem>
              </AccordionDetails>
            </Accordion>



            <Accordion
              expanded={countryLocation}
              onChange={handleCountryLocation}
              disableGutters
              style={{ border: "none", marginTop: '0.5rem', borderRadius: "5px" }}
              sx={{ width: "100%", border: "none" }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="agent-section-content"
                id="agent-section-header"
                sx={{
                  paddingLeft: "15px",
                  "& .MuiAccordionSummary-content": {
                    margin: 0,
                  },
                }}
              >
                <ListItemIcon>
                  <AirplanemodeActiveIcon style={{ color: '#2f034d' }} />
                </ListItemIcon>
                <ListItemText primary="Country Location" />
              </AccordionSummary>
              <AccordionDetails sx={{ padding: "0 16px" }}>
                <ListItem
                  button
                  onClick={() => {
                    navigate("/dashboard/add-country-location");
                    toggleDrawer(false);
                  }}
                >
                  <ListItemIcon>
                    <AppRegistrationIcon style={{ color: '#2f034d' }} />
                  </ListItemIcon>
                  <ListItemText primary="Add Location" />
                </ListItem>

                <ListItem
                  button
                  onClick={() => {
                    navigate("/dashboard/view-country-location");
                    toggleDrawer(false);
                  }}
                >
                  <ListItemIcon>
                    <AccessibilityNewIcon style={{ color: '#2f034d' }} />
                  </ListItemIcon>
                  <ListItemText primary="View Location" />
                </ListItem>
              </AccordionDetails>
            </Accordion>




            <Accordion
              expanded={isVacationOpen}
              onChange={handleisVacationOpen}
              disableGutters
              style={{ border: "none", marginTop: '0.5rem', borderRadius: "5px" }}
              sx={{ width: "100%", border: "none" }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="agent-section-content"
                id="agent-section-header"
                sx={{
                  paddingLeft: "15px",
                  "& .MuiAccordionSummary-content": {
                    margin: 0,
                  },
                }}
              >
                <ListItemIcon>
                  <AddTaskRoundedIcon style={{ color: '#2f034d' }} />
                </ListItemIcon>
                <ListItemText primary="Add Features" />
              </AccordionSummary>
              <AccordionDetails sx={{ padding: "0 16px" }}>
                <ListItem
                  button
                  onClick={() => {
                    navigate("/dashboard/add-features");
                    toggleDrawer(false);
                  }}
                >
                  <ListItemIcon>
                    <AppRegistrationIcon style={{ color: '#2f034d' }} />
                  </ListItemIcon>
                  <ListItemText primary="Add Features" />
                </ListItem>

                <ListItem
                  button
                  onClick={() => {
                    navigate("/dashboard/view-features");
                    toggleDrawer(false);
                  }}
                >
                  <ListItemIcon>
                    <AccessibilityNewIcon style={{ color: '#2f034d' }} />
                  </ListItemIcon>
                  <ListItemText primary="View Features" />
                </ListItem>
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={packageButton}
              onChange={handlepackageButton}
              disableGutters
              style={{ border: "none", marginTop: '0.5rem', borderRadius: "5px" }}
              sx={{ width: "100%", border: "none" }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="agent-section-content"
                id="agent-section-header"
                sx={{
                  paddingLeft: "15px",
                  "& .MuiAccordionSummary-content": {
                    margin: 0,
                  },
                }}
              >
                <ListItemIcon>

                  <HikingIcon style={{ color: '#2f034d' }} />
                </ListItemIcon>
                <ListItemText primary="Add Package" />
              </AccordionSummary>
              <AccordionDetails sx={{ padding: "0 16px" }}>
                <ListItem
                  button
                  onClick={() => {
                    navigate("/dashboard/add-new-package");
                    toggleDrawer(false);
                  }}
                >
                  <ListItemIcon>
                    <AppRegistrationIcon style={{ color: '#2f034d' }} />
                  </ListItemIcon>
                  <ListItemText primary="Add New Package" />
                </ListItem>

                <ListItem
                  button
                  onClick={() => {
                    navigate("/dashboard/view-new-package");
                    toggleDrawer(false);
                  }}
                >
                  <ListItemIcon>
                    <AccessibilityNewIcon style={{ color: '#2f034d' }} />
                  </ListItemIcon>
                  <ListItemText primary="View Packages" />
                </ListItem>
              </AccordionDetails>
            </Accordion>






            <Accordion
              expanded={addBlogs}
              onChange={handleBlogs}
              disableGutters
              style={{ border: "none", marginTop: '0.5rem', borderRadius: "5px" }}
              sx={{ width: "100%", border: "none" }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="agent-section-content"
                id="agent-section-header"
                sx={{
                  paddingLeft: "15px",
                  "& .MuiAccordionSummary-content": {
                    margin: 0,
                  },
                }}
              >
                <ListItemIcon>
                  <BookIcon style={{ color: '#2f034d' }} />
                </ListItemIcon>
                <ListItemText primary="Add Blogs" />
              </AccordionSummary>
              <AccordionDetails sx={{ padding: "0 16px" }}>
                <ListItem
                  button
                  onClick={() => {
                    navigate("/dashboard/add-blogs");
                    toggleDrawer(false);
                  }}
                >
                  <ListItemIcon>
                    <AppRegistrationIcon style={{ color: '#2f034d' }} />
                  </ListItemIcon>
                  <ListItemText primary="Add New Blogs" />
                </ListItem>

                <ListItem
                  button
                  onClick={() => {
                    navigate("/dashboard/view-blogs");
                    toggleDrawer(false);
                  }}
                >
                  <ListItemIcon>
                    <AccessibilityNewIcon style={{ color: '#2f034d' }} />
                  </ListItemIcon>
                  <ListItemText primary="View Blogs" />
                </ListItem>
              </AccordionDetails>
            </Accordion>



            <Accordion
              expanded={leads}
              onChange={toggleLeads}
              disableGutters
              style={{ border: "none", marginTop: '0.5rem', borderRadius: "5px" }}
              sx={{ width: "100%", border: "none" }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="agent-section-content"
                id="agent-section-header"
                sx={{
                  paddingLeft: "15px",
                  "& .MuiAccordionSummary-content": {
                    margin: 0,
                  },
                }}
              >
                <ListItemIcon>
                  <CreateRoundedIcon style={{ color: '#2f034d' }} />
                </ListItemIcon>
                <ListItemText primary="Leads Section" />
              </AccordionSummary>
              <AccordionDetails sx={{ padding: "0 16px" }}>
                <ListItem
                  button
                  onClick={() => {
                    navigate("/dashboard/view-leads");
                    toggleDrawer(false);
                  }}
                >
                  <ListItemIcon>
                    <AppRegistrationIcon style={{ color: '#2f034d' }} />
                  </ListItemIcon>
                  <ListItemText primary="Leads" />
                </ListItem>

              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={offers}
              onChange={toggleOffers}
              disableGutters
              style={{ border: "none", marginTop: '0.5rem', borderRadius: "5px" }}
              sx={{ width: "100%", border: "none" }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="agent-section-content"
                id="agent-section-header"
                sx={{
                  paddingLeft: "15px",
                  "& .MuiAccordionSummary-content": {
                    margin: 0,
                  },
                }}
              >
                <ListItemIcon>
                  <CreateRoundedIcon style={{ color: '#2f034d' }} />
                </ListItemIcon>
                <ListItemText primary="Offers" />
              </AccordionSummary>
              <AccordionDetails sx={{ padding: "0 16px" }}>
                <ListItem
                  button
                  onClick={() => {
                    navigate("/dashboard/create-offers");
                    toggleDrawer(false);
                  }}
                >
                  <ListItemIcon>
                    <AppRegistrationIcon style={{ color: '#2f034d' }} />
                  </ListItemIcon>
                  <ListItemText primary="Create Offers" />
                </ListItem>

              </AccordionDetails>
              <AccordionDetails sx={{ padding: "0 16px" }}>
                <ListItem
                  button
                  onClick={() => {
                    navigate("/dashboard/edit-offers");
                    toggleDrawer(false);
                  }}
                >
                  <ListItemIcon>
                    <AppRegistrationIcon style={{ color: '#2f034d' }} />
                  </ListItemIcon>
                  <ListItemText primary="Edit Offers" />
                </ListItem>

              </AccordionDetails>
            </Accordion>



            <Accordion
              expanded={booking}
              onChange={toggleDrawerBooking}
              disableGutters
              style={{ border: "none", marginTop: '0.5rem', borderRadius: "5px" }}
              sx={{ width: "100%", border: "none" }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="agent-section-content"
                id="agent-section-header"
                sx={{
                  paddingLeft: "15px",
                  "& .MuiAccordionSummary-content": {
                    margin: 0,
                  },
                }}
              >
                <ListItemIcon>
                  <CreateRoundedIcon style={{ color: '#2f034d' }} />
                </ListItemIcon>
                <ListItemText primary="Booking" />
              </AccordionSummary>
              <AccordionDetails sx={{ padding: "0 16px" }}>
                <ListItem
                  button
                  onClick={() => {
                    navigate("/dashboard/addBooking");
                    toggleDrawer(false);
                  }}
                >
                  <ListItemIcon>
                    <AppRegistrationIcon style={{ color: '#2f034d' }} />
                  </ListItemIcon>
                  <ListItemText primary="Create Booking" />
                </ListItem>

              </AccordionDetails>
              <AccordionDetails sx={{ padding: "0 16px" }}>
                <ListItem
                  button
                  onClick={() => {
                    navigate("/dashboard/viewBooking");
                    toggleDrawer(false);
                  }}
                >
                  <ListItemIcon>
                    <AppRegistrationIcon style={{ color: '#2f034d' }} />
                  </ListItemIcon>
                  <ListItemText primary="View Booking" />
                </ListItem>

              </AccordionDetails>
            </Accordion>


            <ListItem
              button
              onClick={() => {
                sweetAlert(
                  "success",
                  "Sign Out",
                  "You are signed out successfully!",
                  () => { },
                  () => { },
                  false
                );
                Signout();
                setOpen(false);
                navigate("/");
              }}
            >
              <ListItemIcon>
                <ExitToAppIcon style={{ color: '#2f034d' }} />
              </ListItemIcon>
              <ListItemText primary="Log out" />
            </ListItem>
          </>
        ) : (
          signIn.map((item, index) => (
            <ListItem
              button
              key={index}
              component={RouterLink}
              to={item.to}
              onClick={() => toggleDrawer(false)}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.route} />
            </ListItem>
          ))
        )}
      </>
    </List>
  );

  return (
    <div>
      <Button onClick={() => toggleDrawer(true)} style={{ color: 'white' }}>
        <MenuOpenIcon style={{ fontSize: "2rem" }} />
      </Button>
      <Drawer
        anchor="right"
        open={open}
        onClose={() => toggleDrawer(false)}
        sx={{
          '& .MuiDrawer-paper': {
            backgroundColor: 'smokewhite',
            color: 'common.black',
            width: '300px',
            // Apply different width for larger screens
            '@media (min-width:900px)': {
              width: "300px",
            },
          },
        }}
      >
        <div style={{ padding: 16 }}>
          {list}
        </div>
      </Drawer>
    </div>
  );
};

export default SimpleDrawer;
